import React from 'react';
import { useParams } from 'react-router-dom';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';
import ReturnOrderDetailPage from '@/temu-platform/modules/aftersales/ReturnOrderDetailPage';
import SemiReturnOrderDetailPage from '@/temu-platform/modules/aftersales/SemiReturnOrderDetailPage';

export default function TemuReturnsDetailRoutePage() {
  const { shopType } = useParams();
  const slug = normalizeTemuShopTypeSlug(shopType) || 'semi';
  if (slug === 'full') {
    return <ReturnOrderDetailPage />;
  }
  return <SemiReturnOrderDetailPage />;
}
